import angular from 'angular'
import './explore.service'
import './rowtype.service'
import './custom_bundle/custombundle.controller'
import './custom_bundle/custombundle.service'
import './custom_channel/customchannel.controller'
import './custom_channel/customchannel.service'
import './custom_feature/customfeature.controller'
import './custom_feature/customfeature.service'
import './custom_set/customset.controller'
import './custom_set/customset.service'

angular
  .module('admin.explore', [
    'admin.explore.service',
    'admin.explore.row.service',
    'admin.explore.customset',
    'admin.explore.customchannel',
    'admin.explore.customset.service',
    'admin.explore.custombundle',
    'admin.explore.customfeature',
  ])
  .controller('ExploreCtrl', ExploreCtrl)

/** @ngInject */
function ExploreCtrl(
  $scope,
  $q,
  $timeout,
  $state,
  ExploreService,
  ExploreRowTypeService,
  UserSegmentationService,
  ExploreCustomSetService,
  ExploreCustomBundleService,
  EventService,
  ExploreCustomFeatureService,
  CsvService,
  ExploreCustomChannelService,
  TranslatorService,
) {
  var vm = this
  vm.items = []
  vm.itemsExplore = []
  vm.itemsExploreNew = []
  vm.userSegmentations = []
  vm.listDefinitions = []
  vm.itemsCustomSet = []
  vm.itemsCustomChannel = []
  vm.itemsCustomBundle = []
  vm.itemsCustomFeature = []
  vm.isOpen = false
  vm.titleCustomChannel = ''
  vm.titleCustomSet = ''
  vm.titleCustomBundle = ''
  vm.titleCustomFeature = ''

  vm.comboItems = [
    {
      name: 'Channel',
      'k-cont': 1,
    },
    {
      name: 'Set',
      'k-cont': 2,
    },
    {
      name: 'Collectible',
      'k-cont': 3,
    },
    {
      name: 'Print',
      'k-cont': 4,
    },
    {
      name: 'Bundle',
      'k-cont': 5,
    },
    {
      name: 'Product',
      'k-cont': 6,
    },
    {
      name: 'Feature Banner',
      'k-cont': 7,
    },
    {
      name: 'User',
      'k-cont': 8,
    },
    {
      name: 'Showcase',
      'k-cont': 9,
    },
    {
      name: 'Post',
      'k-cont': 10,
    },
    {
      name: 'Trade Post',
      'k-cont': 11,
    },
    {
      name: 'Trade',
      'k-cont': 12,
    },
    {
      name: 'Custom Set',
      'k-cont': 13,
    },
    {
      name: 'AD',
      'k-cont': 13,
    },
    {
      name: 'Coin Award',
      'k-cont': 14,
    },
  ]

  vm.openCalendar = function(e, item) {
    e.preventDefault()
    e.stopPropagation()

    item.open = !item.open
  }

  var isDate = function(date) {
    return new Date(date) !== 'Invalid Date' && !isNaN(new Date(date))
  }

  vm.model = {}
  vm.addRow = {}
  vm.newRow = null
  vm.usersPerPage = 15

  function reloadPaginationRow() {
    vm.totalUsers = 0
    vm.oldPage = 0
    vm.currentPage = 15
    vm.first = true
    vm.totalItems = 0
    vm.pagination = {
      current: 1,
    }
  }

  function reloadPaginationCustomChannel() {
    vm.totalUsersChannel = 0
    vm.oldPageChannel = 0
    vm.currentPageChannel = 15
    vm.firstChannel = true
    vm.totalItemsChannel = 0
    vm.paginationChannel = {
      current: 1,
    }
  }

  function reloadPaginationCustomSet() {
    vm.totalUsers2 = 0
    vm.oldPage2 = 0
    vm.currentPage2 = 15
    vm.first2 = true
    vm.totalItems2 = 0
    vm.pagination2 = {
      current: 1,
    }
  }

  function reloadPaginationCustomBundle() {
    vm.totalUsers3 = 0
    vm.oldPage3 = 0
    vm.currentPage3 = 15
    vm.first3 = true
    vm.totalItems3 = 0
    vm.pagination3 = {
      current: 1,
    }
  }

  function reloadPaginationCustomFeature() {
    vm.totalUsers4 = 0
    vm.oldPage4 = 0
    vm.currentPage4 = 15
    vm.first4 = true
    vm.totalItems4 = 0
    vm.pagination4 = {
      current: 1,
    }
  }

  reloadPaginationRow()
  reloadPaginationCustomChannel()
  reloadPaginationCustomSet()
  reloadPaginationCustomBundle()
  reloadPaginationCustomFeature()

  var tab = localStorage.getItem('explore_tab')
  if (tab !== null) {
    if (tab === 'explorer') {
      $('#drop').removeClass('active')
      $('#rowtype').removeClass('active')
      $('#customchannel').removeClass('active')
      $('#customset').removeClass('active')
      $('#custombundle').removeClass('active')
      $('#customfeature').removeClass('active')
      $('#explore').addClass('active')
      $('#exploretab').addClass('active')
    } else if (tab === 'rowtype') {
      $('#drop').removeClass('active')
      $('#explore').removeClass('active')
      $('#customchannel').removeClass('active')
      $('#customset').removeClass('active')
      $('#custombundle').removeClass('active')
      $('#customfeature').removeClass('active')
      $('#rowtype').addClass('active')
      $('#rowtypetab').addClass('active')
    } else if (tab === 'customchannel') {
      $('#drop').removeClass('active')
      $('#explore').removeClass('active')
      $('#rowtype').removeClass('active')
      $('#customset').removeClass('active')
      $('#custombundle').removeClass('active')
      $('#customfeature').removeClass('active')
      $('#customchannel').addClass('active')
      $('#customchanneltab').addClass('active')
    } else if (tab === 'customset') {
      $('#drop').removeClass('active')
      $('#explore').removeClass('active')
      $('#rowtype').removeClass('active')
      $('#customchannel').removeClass('active')
      $('#custombundle').removeClass('active')
      $('#customfeature').removeClass('active')
      $('#customset').addClass('active')
      $('#customsettab').addClass('active')
    } else if (tab === 'custombundle') {
      $('#drop').removeClass('active')
      $('#explore').removeClass('active')
      $('#rowtype').removeClass('active')
      $('#customchannel').removeClass('active')
      $('#customset').removeClass('active')
      $('#customfeature').removeClass('active')
      $('#custombundle').addClass('active')
      $('#custombundletab').addClass('active')
    } else if (tab === 'customfeature') {
      $('#drop').removeClass('active')
      $('#explore').removeClass('active')
      $('#rowtype').removeClass('active')
      $('#customchannel').removeClass('active')
      $('#customset').removeClass('active')
      $('#custombundle').removeClass('active')
      $('#customfeature').addClass('active')
      $('#customfeaturetab').addClass('active')
    } else if (tab === 'drop') {
      $('#explore').removeClass('active')
      $('#rowtype').removeClass('active')
      $('#customchannel').removeClass('active')
      $('#customset').removeClass('active')
      $('#custombundle').removeClass('active')
      $('#customfeature').removeClass('active')
      $('#drop').addClass('active')
      $('#droptab').addClass('active')
    }
  } else {
    $('#explore').removeClass('active')
    $('#rowtype').removeClass('active')
    $('#customchannel').removeClass('active')
    $('#customset').removeClass('active')
    $('#customfeature').removeClass('active')
    $('#explore').addClass('active')
    $('#exploretab').addClass('active')
  }

  vm.tabExplorer = function() {
    $('#rowtype').removeClass('active')
    $('#customset').removeClass('active')
    $('#customchannel').removeClass('active')
    $('#custombundle').removeClass('active')
    $('#customfeature').removeClass('active')
    $('#drop').removeClass('active')
    $('#explore').addClass('active')
    localStorage.setItem('explore_tab', 'explorer')
  }

  vm.tabDrop = function() {
    $('#rowtype').removeClass('active')
    $('#customset').removeClass('active')
    $('#customchannel').removeClass('active')
    $('#custombundle').removeClass('active')
    $('#customfeature').removeClass('active')
    $('#explore').removeClass('active')
    $('#drop').addClass('active')
    localStorage.setItem('explore_tab', 'drop')
  }

  vm.tabRow = function() {
    $('#explore').removeClass('active')
    $('#customset').removeClass('active')
    $('#customchannel').removeClass('active')
    $('#custombundle').removeClass('active')
    $('#customfeature').removeClass('active')
    $('#drop').removeClass('active')
    $('#rowtype').addClass('active')
    localStorage.setItem('explore_tab', 'rowtype')
  }

  vm.tabCustomChannel = function() {
    $('#rowtype').removeClass('active')
    $('#explore').removeClass('active')
    $('#customset').removeClass('active')
    $('#custombundle').removeClass('active')
    $('#customfeature').removeClass('active')
    $('#drop').removeClass('active')
    $('#customchannel').addClass('active')
    localStorage.setItem('explore_tab', 'customchannel')
  }

  vm.tabCustomSet = function() {
    $('#rowtype').removeClass('active')
    $('#explore').removeClass('active')
    $('#customchannel').removeClass('active')
    $('#custombundle').removeClass('active')
    $('#customfeature').removeClass('active')
    $('#drop').removeClass('active')
    $('#customset').addClass('active')
    localStorage.setItem('explore_tab', 'customset')
  }

  vm.tabBundleSet = function() {
    $('#rowtype').removeClass('active')
    $('#explore').removeClass('active')
    $('#customchannel').removeClass('active')
    $('#customset').removeClass('active')
    $('#customfeature').removeClass('active')
    $('#drop').removeClass('active')
    $('#custombundle').addClass('active')
    localStorage.setItem('explore_tab', 'custombundle')
  }

  vm.tabCustomFeature = function() {
    $('#rowtype').removeClass('active')
    $('#explore').removeClass('active')
    $('#customchannel').removeClass('active')
    $('#custombundle').removeClass('active')
    $('#customset').removeClass('active')
    $('#drop').removeClass('active')
    $('#customfeature').addClass('active')
    localStorage.setItem('explore_tab', 'customfeature')
  }

  load()
  loadRowType(1)
  loadCustomChannel(1)
  loadCustomSet(1)
  loadCustomBundle(1)
  loadCustomFeature(1)

  function load() {
    ExploreService.list().then(function(result) {
      var items = result.results
      vm.itemsExplore = _.filter(items, { k: 0 })
      vm.itemsExploreNew = _.filter(items, { k: 1 })
    })

    ExploreRowTypeService.listAll().then(function(result) {
      vm.itemsAll = result.results
      vm.itemsAllNew = _.filter(result.results, function(item) {
        return item.url.indexOf('banner_list') !== -1 && item['k-cont'] === 7
      })
    })

    ExploreCustomChannelService.listAll().then(function(result) {
      vm.itemsCustomChannelAll = result.results
    })

    ExploreCustomSetService.listAll().then(function(result) {
      vm.itemsCustomSetAll = result.results
    })

    ExploreCustomBundleService.listAll().then(function(result) {
      vm.itemsCustomBundleAll = result.results
    })

    ExploreCustomFeatureService.listAll().then(function(result) {
      vm.itemsCustomFeatureAll = result.results
    })
  }

  // var makeTranslation = function(text, currentTranslations, paramsId, route) {
  //   var defered = $q.defer()

  //   TranslatorService.translateText(text).then(function(res) {
  //     var languages = ['ja', 'ko', 'zh', 'zh-TW']

  //     for (var i = 0; i < currentTranslations.length; i++) {
  //       for (var key in res.results) {
  //         if (currentTranslations[i].comm === 'JP' && key.indexOf('ja') !== -1) {
  //           languages.remove('ja')
  //         }
  //         if (currentTranslations[i].comm === 'KR' && key.indexOf('ko') !== -1) {
  //           languages.remove('ko')
  //         }
  //         if (currentTranslations[i].comm === 'SC' && key.indexOf('zh') !== -1) {
  //           languages.remove('zh')
  //         }
  //         if (currentTranslations[i].comm === 'TC' && key.indexOf('zh-TW') !== -1) {
  //           languages.remove('zh-TW')
  //         }
  //       }
  //     }

  //     // if (vm.title === text && languages.length === 0) {
  //     //   defered.resolve()
  //     //   return
  //     // }
  //     if (vm.model.id !== undefined && vm.model.id !== '' && vm.model.id !== 0) {
  //       var promises = []

  //       for (var i = 0; i < currentTranslations.length; i++) {
  //         if (currentTranslations[i].comm === 'SC' && res.results) {
  //           var exist = _.find(languages, 'zh')
  //           if (exist) {
  //             promises.push(
  //               ExploreRowTypeService.createTranslation(paramsId, {
  //                 'id-u': 0,
  //                 comm: 'SC',
  //                 t: res.results.zh,
  //               }),
  //             )
  //           } else {
  //             promises.push(
  //               ExploreRowTypeService.updateTranslation(currentTranslations[i].id, {
  //                 t: res.results.zh,
  //               }),
  //             )
  //           }
  //           continue
  //         }
  //         if (currentTranslations[i].comm === 'TC' && res.results) {
  //           var exist = _.find(languages, 'zh-TW')
  //           if (exist) {
  //             promises.push(
  //               ExploreRowTypeService.createTranslation(paramsId, {
  //                 'id-u': 0,
  //                 comm: 'TC',
  //                 t: res.results['zh-TW'],
  //               }),
  //             )
  //           } else {
  //             promises.push(
  //               ExploreRowTypeService.updateTranslation(currentTranslations[i].id, {
  //                 t: res.results['zh-TW'],
  //               }),
  //             )
  //           }
  //           continue
  //         }
  //         if (currentTranslations[i].comm === 'KR' && res.results) {
  //           var exist = _.find(languages, 'ko')
  //           if (exist) {
  //             promises.push(
  //               ExploreRowTypeService.createTranslation(paramsId, {
  //                 'id-u': 0,
  //                 comm: 'KR',
  //                 t: res.results.ko,
  //               }),
  //             )
  //           } else {
  //             promises.push(
  //               ExploreRowTypeService.updateTranslation(currentTranslations[i].id, {
  //                 t: res.results.ko,
  //               }),
  //             )
  //           }
  //           continue
  //         }
  //         if (currentTranslations[i].comm === 'JP' && res.results) {
  //           var exist = _.find(languages, 'ja')
  //           if (exist) {
  //             promises.push(
  //               ExploreRowTypeService.createTranslation(paramsId, {
  //                 'id-u': 0,
  //                 comm: 'JP',
  //                 t: res.results.ja,
  //               }),
  //             )
  //           } else {
  //             promises.push(
  //               ExploreRowTypeService.updateTranslation(currentTranslations[i].id, {
  //                 t: res.results.ja,
  //               }),
  //             )
  //           }
  //           continue
  //         }
  //       }

  //       $q.all(promises)
  //         .then(function() {
  //           defered.resolve()
  //         })
  //         .catch(function(err) {
  //           swal('Error in translation, please send message to qp2 administrator!', '', 'error')
  //           defered.reject()
  //         })
  //     }

  //     var promises = []

  //     for (var i = 0; i < languages.length; i++) {
  //       if (languages[i] === 'zh' && res.results) {
  //         promises.push(
  //           ExploreRowTypeService.createTranslation(paramsId, {
  //             'id-u': 0,
  //             comm: 'SC',
  //             t: res.results.zh,
  //           }),
  //         )
  //       }
  //       if (languages[i] === 'zh-TW' && res.results) {
  //         promises.push(
  //           ExploreRowTypeService.createTranslation(paramsId, {
  //             'id-u': 0,
  //             comm: 'TC',
  //             t: res.results['zh-TW'],
  //           }),
  //         )
  //       }
  //       if (languages[i] === 'ko' && res.results) {
  //         promises.push(
  //           ExploreRowTypeService.createTranslation(paramsId, {
  //             'id-u': 0,
  //             comm: 'KR',
  //             t: res.results.ko,
  //           }),
  //         )
  //       }
  //       if (languages[i] === 'ja' && res.results) {
  //         promises.push(
  //           ExploreRowTypeService.createTranslation(paramsId, {
  //             'id-u': 0,
  //             comm: 'JP',
  //             t: res.results.ja,
  //           }),
  //         )
  //       }
  //     }

  //     $q.all(promises)
  //       .then(function() {
  //         defered.resolve()
  //       })
  //       .catch(function() {
  //         swal('Error in translation, please send message to qp2 administrator!', '', 'error')
  //         defered.reject()
  //       })
  //   })

  //   return defered.promise
  // }

  function loadRowType(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination.current = 1
    }
    if (!vm.first) {
      vm.currentPage = pageNumber * 15
      vm.oldPage = vm.currentPage - 15
    } else {
      vm.first = false
    }

    ExploreRowTypeService.list(vm.oldPage, 15).then(function(result) {
      if (vm.totalItems === 0) {
        vm.totalItems = result.ct
      }
      vm.items = result.results
    })
  }

  function loadCustomChannel(pageNumber) {
    if (pageNumber === 1) {
      vm.paginationChannel.current = 1
    }
    if (!vm.firstChannel) {
      vm.currentPageChannel = pageNumber * 15
      vm.oldPageChannel = vm.currentPageChannel - 15
    } else {
      vm.firstChannel = false
    }

    ExploreCustomChannelService.list(vm.titleCustomChannel, vm.oldPageChannel, 15).then(function(
      result,
    ) {
      if (vm.totalItemsChannel === 0) {
        vm.totalItemsChannel = result.ct
      }
      vm.itemsCustomChannel = result.results
    })
  }

  function loadCustomSet(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination2.current = 1
    }
    if (!vm.first2) {
      vm.currentPage2 = pageNumber * 15
      vm.oldPage2 = vm.currentPage2 - 15
    } else {
      vm.first2 = false
    }

    ExploreCustomSetService.list(vm.titleCustomSet, vm.oldPage2, 15).then(function(result) {
      if (vm.totalItems2 === 0) {
        vm.totalItems2 = result.ct
      }
      vm.itemsCustomSet = result.results
    })
  }

  function loadCustomBundle(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination3.current = 1
    }
    if (!vm.first3) {
      vm.currentPage3 = pageNumber * 15
      vm.oldPage3 = vm.currentPage3 - 15
    } else {
      vm.first3 = false
    }

    ExploreCustomBundleService.list(vm.titleCustomBundle, vm.oldPage3, 15).then(function(result) {
      if (vm.totalItems3 === 0) {
        vm.totalItems3 = result.ct
      }
      vm.itemsCustomBundle = result.results
    })
  }

  function loadCustomFeature(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination4.current = 1
    }
    if (!vm.first4) {
      vm.currentPage4 = pageNumber * 15
      vm.oldPage4 = vm.currentPage4 - 15
    } else {
      vm.first4 = false
    }

    ExploreCustomFeatureService.list(vm.titleCustomFeature, vm.oldPage4, 15).then(function(result) {
      if (vm.totalItems4 === 0) {
        vm.totalItems4 = result.ct
      }
      vm.itemsCustomFeature = result.results
    })
  }

  EventService.listChannels().then(function(result) {
    vm.channels = result.results
  })

  UserSegmentationService.listAll().then(function(result) {
    vm.userSegmentations = result.results
  })

  vm.add = function() {
    vm.newRow = null
    vm.addRow = {}
    vm.customBundle = null
    vm.customChannel = null
    vm.customSet = null
    vm.customFeature = null
    vm.model.id = 0
    $('#myModalAdd').modal('show')
  }

  vm.addButtonCustomChannel = function() {
    vm.addCustomChannel = {}
    vm.modelCustomChannel = {
      id: 0,
    }
    $('#myModalCustomChannelAdd').modal('show')
  }

  vm.addButtonCustomSet = function() {
    vm.addCustomSet = {}
    vm.modelCustomSet = {
      id: 0,
    }
    $('#myModalCustomSetAdd').modal('show')
  }

  vm.addButtonCustomBundle = function() {
    vm.addCustomBundle = {}
    vm.modelCustomBundle = {
      id: 0,
    }
    $('#myModalCustomBundleAdd').modal('show')
  }

  vm.addButtonCustomFeature = function() {
    vm.addCustomFeature = {}
    vm.modelCustomFeature = {
      id: 0,
    }
    $('#myModalCustomFeatureAdd').modal('show')
  }

  vm.addExplore = function(type) {
    vm.exploreType = type
    vm.newRow = null
    vm.addRow = {}
    vm.nameExplore = null
    vm.dateExplore = null
    vm.exploreId = 0
    vm.exploreSegmentations = []
    vm.listDefinitions = []
    $('#myModalAddExplore').modal('show')
  }

  vm.edit = function(item) {
    vm.model.id = item.id
    vm['k-cont'] = item['k-cont']
    vm.model.nm = item.nm
    vm.model.t = item.t
    vm.model.txt = item.txt
    vm.model.url = item.url
    if (vm['k-cont'] === 1 && item.url.split('channel_lists/')[1] !== undefined) {
      vm.customChannel = parseInt(item.url.split('channel_lists/')[1].split('/')[0])
    } else {
      vm.customChannel = null
    }
    if (vm['k-cont'] === 2 && item.url.split('set_lists/')[1] !== undefined) {
      vm.customSet = parseInt(item.url.split('set_lists/')[1].split('/')[0])
    } else {
      vm.customSet = null
    }
    if (vm['k-cont'] === 5 && item.url.split('bundle_lists/')[1] !== undefined) {
      vm.customBundle = parseInt(item.url.split('bundle_lists/')[1].split('/')[0])
    } else {
      vm.customBundle = null
    }
    if (vm['k-cont'] === 7 && item.url.split('banner_lists/')[1] !== undefined) {
      vm.customFeature = parseInt(item.url.split('banner_lists/')[1].split('/')[0])
    } else {
      vm.customFeature = null
    }
    loadTranslations(item)
    $('#myModalEdit').modal('show')
  }

  vm.editExplore = function(type, item) {
    vm.exploreType = type
    ExploreService.listSegments(item.id).then(function(result) {
      var items = result.results
      var exploreSegmentations = []
      for (var i = 0; i < items.length; i++) {
        exploreSegmentations.push(items[i].id)
      }
      vm.exploreSegmentations = exploreSegmentations
      vm.existExploreSegmentations = items
      vm.nameExplore = item.nm
      vm.rowCount = item.cr

      vm.exploreId = item.id
      var json = JSON.parse(item.dfn)
      vm.listDefinitions = []
      for (var i = 0; i < json.length; i++) {
        if (json[i]['ts-x'] !== undefined && json[i]['ts-x'] !== 0) {
          json[i]['ts-x'] = json[i]['ts-x']
            .toString()
            .substring(0, json[i]['ts-x'].toString().length - 3)
          json[i]['ts-x'] = new Date(parseInt(json[i]['ts-x']))
        }
        vm.listDefinitions.push({
          id: json[i].id,
          'id-us': json[i]['id-us'],
          'ts-x': json[i]['ts-x'],
          open: false,
        })
      }
      $('#myModalAddExplore').modal('show')
    })
  }

  vm.editCustomChannel = function(item) {
    vm.modelCustomChannel = {
      id: item.id,
      nm: item.nm,
    }
    vm.addCustomChannel = {
      nm: item.nm,
    }
    $('#myModalCustomChannelAdd').modal('show')
  }

  vm.editCustomSet = function(item) {
    vm.modelCustomSet = {
      id: item.id,
      nm: item.nm,
    }
    vm.addCustomSet = {
      nm: item.nm,
    }
    $('#myModalCustomSetAdd').modal('show')
  }

  vm.editCustomBundle = function(item) {
    vm.modelCustomBundle = {
      id: item.id,
      nm: item.nm,
    }
    vm.addCustomBundle = {
      nm: item.nm,
    }
    $('#myModalCustomBundleAdd').modal('show')
  }

  vm.editCustomFeature = function(item) {
    vm.modelCustomFeature = {
      id: item.id,
      nm: item.nm,
    }
    vm.addCustomFeature = {
      nm: item.nm,
    }
    $('#myModalCustomFeatureAdd').modal('show')
  }

  vm.saveAdd = function() {
    if (vm.newRow === undefined || vm.newRow === null || vm.newRow === '') {
      swal('You need select a type', '', 'warning')
      return
    }

    if (vm.addRow.nm === undefined || vm.addRow.nm === null || vm.addRow.nm === '') {
      swal('You need add name field', '', 'warning')
      return
    }

    if (vm.addRow.url === undefined || vm.addRow.url === null || vm.addRow.url === '') {
      swal('You need add url field', '', 'warning')
      return
    }

    var row = {
      nm: vm.addRow.nm,
      t: vm.addRow.t,
      txt: vm.addRow.txt,
      url: vm.addRow.url,
      'k-cont': vm.newRow,
    }

    ExploreRowTypeService.create(row).then(function(result) {
      // makeTranslation(vm.addRow.t, vm.explorerTranslations, result.results.id, '').then(
        // function() {
      $('#myModalAdd').modal('hide')
      vm.addRow = {}
      loadRowType(vm.pagination.current)
      load()
        // },
        // function() {
        //   $('#myModalAdd').modal('hide')
        //   vm.addRow = {}
        //   loadRowType(vm.pagination.current)
        //   load()
        // },
      // )
    })
  }

  vm.saveAddExplore = function() {
    if (vm.nameExplore === undefined || vm.nameExplore === null || vm.nameExplore === '') {
      swal('You need add a Explore Name', '', 'warning')
      return
    }

    if (vm.listDefinitions.length === 0) {
      swal('You need create a Explore Row Type', '', 'warning')
      return
    }

    for (var i = 0; i < vm.listDefinitions.length; i++) {
      if (vm.listDefinitions[i]['ts-x'] !== undefined) {
        if (isDate(vm.listDefinitions[i]['ts-x'])) {
          var date = parseInt(new Date(vm.listDefinitions[i]['ts-x']).getTime() + '000')
          vm.listDefinitions[i]['ts-x'] = date
        } else {
          toastr.warning('Date field invalid!')
          vm.listDefinitions[i].open = true
          $('#date' + i).focus()
          return
        }
      }

      if (vm.listDefinitions[i].id === 0) {
        swal('You have a row empty fill it first', '', 'warning')
        return
      }

      delete vm.listDefinitions[i].open
    }

    var row = {
      nm: vm.nameExplore,
      'ts-x': vm.dateExploreSave,
      dfn: JSON.stringify(vm.listDefinitions),
      k: vm.exploreType === 'explore' ? 0 : 1,
    }

    if (vm.exploreType === 'new') {
      row.cr = !vm.rowCount ? null : vm.rowCount
    }

    if (vm.exploreId === 0) {
      ExploreService.create(row).then(
        function(result) {
          $('#myModalAddExplore').modal('hide')
          vm.nameExplore = null
          vm.dateExplore = null
          vm.listDefinitions = []
          load()
        },
        function(err) {
          $timeout(function() {
            swal(err.error.message, '', 'error')
          }, 400)
        },
      )
    } else {
      ExploreService.update(vm.exploreId, row).then(
        function() {
          $('#myModalAddExplore').modal('hide')
          vm.nameExplore = null
          vm.dateExplore = null
          vm.listDefinitions = []
          load()
        },
        function(err) {
          $timeout(function() {
            swal(err.error.message, '', 'error')
          }, 400)
        },
      )
    }
  }

  $('#mySelect2').on('change', function(e) {
    if (e.added !== undefined) {
      ExploreService.addSegment(vm.exploreId, e.added.obj.id).then(
        function() {},
        function(err) {
          swal(err.error.message, '', 'error')
          var arr = $('#mySelect2')
            .val()
            .split(',')
            .map(function(item) {
              return parseInt(item)
            })
          var newArr = ''
          for (var i = 0; i < arr.length; i++) {
            if (arr[i] !== e.added.obj.id) {
              newArr += arr[i].toString() + ','
            }
          }

          $('#mySelect2').val(newArr)

          $('#s2id_mySelect2 .select2-search-choice').each(function() {
            if (
              $(this)
                .text()
                .trim() === e.added.obj.t
            ) {
              $(this).remove()
            }
          })

          vm.exploreSegmentations.remove(e.added.obj)
        },
      )
    }
    if (e.removed !== undefined) {
      ExploreService.removeSegment(vm.exploreId, e.removed.obj.id).then(
        function() {},
        function(err) {
          swal(err.error.message, '', 'error')
        },
      )
    }
  })

  vm.saveAddCustomChannel = function() {
    if (
      vm.addCustomChannel.nm === undefined ||
      vm.addCustomChannel.nm === null ||
      vm.addCustomChannel.nm === ''
    ) {
      swal('You need add name field', '', 'warning')
      return
    }

    var row = {
      nm: vm.addCustomChannel.nm,
    }

    if (vm.modelCustomChannel.id === 0) {
      ExploreCustomChannelService.create(row).then(
        function() {
          $('#myModalCustomChannelAdd').modal('hide')
          vm.addCustomChannel = {}
          loadCustomChannel(vm.paginationChannel.current)
          load()
        },
        function(err) {
          $timeout(function() {
            if (err.error.message.indexOf('uix_channel_lists_name') !== -1) {
              swal('That name is already in use, please try another.', '', 'error')
            } else {
              swal(err.error.message, '', 'error')
            }
          }, 400)
        },
      )
    } else {
      ExploreCustomChannelService.update(vm.modelCustomChannel.id, row).then(
        function() {
          $('#myModalCustomChannelAdd').modal('hide')
          vm.addCustomChannel = {}
          loadCustomChannel(vm.paginationChannel.current)
          load()
        },
        function(err) {
          $timeout(function() {
            if (err.error.message.indexOf('uix_channel_lists_name') !== -1) {
              swal('That name is already in use, please try another.', '', 'error')
            } else {
              swal(err.error.message, '', 'error')
            }
          }, 400)
        },
      )
    }
  }

  vm.saveAddCustomSet = function() {
    if (
      vm.addCustomSet.nm === undefined ||
      vm.addCustomSet.nm === null ||
      vm.addCustomSet.nm === ''
    ) {
      swal('You need add name field', '', 'warning')
      return
    }

    var row = {
      nm: vm.addCustomSet.nm,
    }

    if (vm.modelCustomSet.id === 0) {
      ExploreCustomSetService.create(row).then(
        function() {
          $('#myModalCustomSetAdd').modal('hide')
          vm.addCustomSet = {}
          loadCustomSet(vm.pagination2.current)
          load()
        },
        function(err) {
          $timeout(function() {
            if (err.error.message.indexOf('uix_set_lists_name') !== -1) {
              swal('That name is already in use, please try another.', '', 'error')
            } else {
              swal(err.error.message, '', 'error')
            }
          }, 400)
        },
      )
    } else {
      ExploreCustomSetService.update(vm.modelCustomSet.id, row).then(
        function() {
          $('#myModalCustomSetAdd').modal('hide')
          vm.addCustomSet = {}
          loadCustomSet(vm.pagination2.current)
          load()
        },
        function(err) {
          $timeout(function() {
            if (err.error.message.indexOf('uix_set_lists_name') !== -1) {
              swal('That name is already in use, please try another.', '', 'error')
            } else {
              swal(err.error.message, '', 'error')
            }
          }, 400)
        },
      )
    }
  }

  vm.saveAddCustomBundle = function() {
    if (
      vm.addCustomBundle.nm === undefined ||
      vm.addCustomBundle.nm === null ||
      vm.addCustomBundle.nm === ''
    ) {
      swal('You need add name field', '', 'warning')
      return
    }

    var row = {
      nm: vm.addCustomBundle.nm,
    }

    if (vm.modelCustomBundle.id === 0) {
      ExploreCustomBundleService.create(row).then(
        function() {
          $('#myModalCustomBundleAdd').modal('hide')
          vm.addCustomBundle = {}
          loadCustomBundle(vm.pagination3.current)
          load()
        },
        function(err) {
          $timeout(function() {
            if (err.error.message.indexOf('uix_bundle_lists_name') !== -1) {
              swal('That name is already in use, please try another.', '', 'error')
            } else {
              swal(err.error.message, '', 'error')
            }
          }, 400)
        },
      )
    } else {
      ExploreCustomBundleService.update(vm.modelCustomBundle.id, row).then(
        function() {
          $('#myModalCustomBundleAdd').modal('hide')
          vm.addCustomBundle = {}
          loadCustomBundle(vm.pagination3.current)
          load()
        },
        function(err) {
          $timeout(function() {
            if (err.error.message.indexOf('uix_bundle_lists_name') !== -1) {
              swal('That name is already in use, please try another.', '', 'error')
            } else {
              swal(err.error.message, '', 'error')
            }
          }, 400)
        },
      )
    }
  }

  vm.saveAddCustomFeature = function() {
    if (
      vm.addCustomFeature.nm === undefined ||
      vm.addCustomFeature.nm === null ||
      vm.addCustomFeature.nm === ''
    ) {
      swal('You need add name field', '', 'warning')
      return
    }

    var row = {
      nm: vm.addCustomFeature.nm,
    }

    if (vm.modelCustomFeature.id === 0) {
      ExploreCustomFeatureService.create(row).then(
        function() {
          $('#myModalCustomFeatureAdd').modal('hide')
          vm.addCustomFeature = {}
          loadCustomFeature(vm.pagination4.current)
          load()
        },
        function(err) {
          $timeout(function() {
            if (err.error.message.indexOf('uix_banner_lists_name') !== -1) {
              swal('That name is already in use, please try another.', '', 'error')
            } else {
              swal(err.error.message, '', 'error')
            }
          }, 400)
        },
      )
    } else {
      ExploreCustomFeatureService.update(vm.modelCustomFeature.id, row).then(
        function() {
          $('#myModalCustomFeatureAdd').modal('hide')
          vm.addCustomFeature = {}
          loadCustomFeature(vm.pagination4.current)
          load()
        },
        function(err) {
          $timeout(function() {
            if (err.error.message.indexOf('uix_banner_lists_name') !== -1) {
              swal('That name is already in use, please try another.', '', 'error')
            } else {
              swal(err.error.message, '', 'error')
            }
          }, 400)
        },
      )
    }
  }

  vm.cancelAdd = function() {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function(isConfirm) {
        if (isConfirm) {
          $timeout(function() {
            $('#myModalAdd').modal('hide')
          }, 250)
        } else {
          return
        }
      },
    )
  }

  vm.cancelAddExplore = function() {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function(isConfirm) {
        if (isConfirm) {
          $timeout(function() {
            vm.listDefinitions = []
            $('#myModalAddExplore').modal('hide')
          }, 250)
        } else {
          return
        }
      },
    )
  }

  vm.cancelAddCustomChannel = function() {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function(isConfirm) {
        if (isConfirm) {
          $timeout(function() {
            $('#myModalCustomChannelAdd').modal('hide')
          }, 250)
        } else {
          return
        }
      },
    )
  }

  vm.cancelAddCustomSet = function() {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function(isConfirm) {
        if (isConfirm) {
          $timeout(function() {
            $('#myModalCustomSetAdd').modal('hide')
          }, 250)
        } else {
          return
        }
      },
    )
  }

  vm.cancelAddCustomBundle = function() {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function(isConfirm) {
        if (isConfirm) {
          $timeout(function() {
            $('#myModalCustomBundleAdd').modal('hide')
          }, 250)
        } else {
          return
        }
      },
    )
  }

  vm.cancelAddCustomFeature = function() {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function(isConfirm) {
        if (isConfirm) {
          $timeout(function() {
            $('#myModalCustomFeatureAdd').modal('hide')
          }, 250)
        } else {
          return
        }
      },
    )
  }

  vm.newRowType = function() {
    for (var i = 0; i < vm.listDefinitions.length; i++) {
      if (vm.listDefinitions[i].id === 0) {
        swal('You have a row empty fill it first', '', 'warning')
        return
      }
    }
    vm.listDefinitions.push({
      id: 0,
      'id-us': [],
      open: false,
    })
  }

  vm.deleteDefinition = function(item) {
    vm.listDefinitions.remove(item)
  }

  vm.saveEdit = function() {
    if (vm.model.t === null || vm.model.t === undefined) {
      vm.model.t = ''
    }

    if (vm.model.txt === null || vm.model.txt === undefined) {
      vm.model.txt = ''
    }

    ExploreRowTypeService.update(vm.model.id, vm.model).then(function() {
      $('#myModalEdit').modal('hide')
      loadRowType(vm.pagination.current)
      load()
      // makeTranslation(vm.model.t, vm.explorerTranslations, vm.model.id, '')

    })
  }

  vm.cancelEdit = function() {
    $('#myModalEdit').modal('hide')
  }

  vm.delete = function(item) {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function(isConfirm) {
        if (isConfirm) {
          $timeout(function() {
            ExploreRowTypeService.remove(item.id).then(
              function() {
                $state.reload()
              },
              function() {
                swal(
                  'This row is currently used by a published Explore Screen! Un-publish that explore screen and try again or Delete all translations attached on this row.',
                  '',
                  'error',
                )
              },
            )
          }, 350)
        } else {
          return
        }
      },
    )
  }

  vm.deleteExplore = function(type, item) {
    vm.exploreType = type
    if (item.st === 1) {
      swal('You cannot delete Explore screen published', '', 'error')
      return
    }

    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function(isConfirm) {
        if (isConfirm) {
          $timeout(function() {
            ExploreService.remove(item.id).then(
              function() {
                load()
              },
              function(err) {
                swal(err.error.message)
              },
            )
          }, 250)
        } else {
          return
        }
      },
    )
  }

  vm.deleteCustomChannel = function(item) {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function(isConfirm) {
        if (isConfirm) {
          if (item.clc !== undefined) {
            if (item.clc.length > 0) {
              $timeout(function() {
                swal('You have channels associate with this custom channel', '', 'warning')
              }, 350)
              return
            }
          } else {
            $timeout(function() {
              ExploreCustomChannelService.remove(item.id).then(
                function() {
                  $state.reload()
                },
                function(err) {
                  swal(err.error.message)
                },
              )
            }, 250)
          }
        } else {
          return
        }
      },
    )
  }

  vm.deleteCustomSet = function(item) {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function(isConfirm) {
        if (isConfirm) {
          if (item.sls !== undefined) {
            if (item.sls.length > 0) {
              $timeout(function() {
                swal('You have sets associate with this custom set', '', 'warning')
              }, 350)
              return
            }
          } else {
            $timeout(function() {
              ExploreCustomSetService.remove(item.id).then(
                function() {
                  $state.reload()
                },
                function(err) {
                  swal(err.error.message)
                },
              )
            }, 250)
          }
        } else {
          return
        }
      },
    )
  }

  vm.deleteCustomBundle = function(item) {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function(isConfirm) {
        if (isConfirm) {
          if (item.blb !== undefined) {
            if (item.blb.length > 0) {
              $timeout(function() {
                swal('You have bundles associate with this custom bundle', '', 'warning')
              }, 350)
              return
            }
          } else {
            $timeout(function() {
              ExploreCustomBundleService.remove(item.id).then(
                function() {
                  $state.reload()
                },
                function(err) {
                  swal(err.error.message)
                },
              )
            }, 250)
          }
        } else {
          return
        }
      },
    )
  }

  vm.deleteCustomFeature = function(item) {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function(isConfirm) {
        if (isConfirm) {
          if (item.balba !== undefined) {
            if (item.balba.length > 0) {
              $timeout(function() {
                swal('You have banner associate with this custom feature banner', '', 'warning')
              }, 350)
              return
            }
          } else {
            $timeout(function() {
              ExploreCustomFeatureService.remove(item.id).then(
                function() {
                  $state.reload()
                },
                function(err) {
                  swal(err.error.message)
                },
              )
            }, 250)
          }
        } else {
          return
        }
      },
    )
  }

  vm.publish = function(item) {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function(isConfirm) {
        if (isConfirm) {
          $timeout(function() {
            ExploreService.publish(item.id, { st: 1 }).then(
              function() {
                load()
              },
              function(err) {
                swal(err.error.message)
              },
            )
          }, 250)
        } else {
          return
        }
      },
    )
  }

  vm.unpublish = function(item) {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function(isConfirm) {
        if (isConfirm) {
          $timeout(function() {
            ExploreService.unpublish(item.id).then(
              function() {
                load()
              },
              function(err) {
                swal(err.error.message)
              },
            )
          }, 250)
        } else {
          return
        }
      },
    )
  }

  vm.barConfig = {
    animation: 150,
    handle: '.handle',
    onEnd: function(/** ngSortEvent */ evt) {
      var newIdx = parseInt(evt.newIndex) + 1
      ExploreService.reorder(evt.model.id, newIdx).then(function() {
        load()
      })
    },
  }

  vm.barConfigTypes = {
    animation: 150,
    handle: '.handle',
    onEnd: function(/** ngSortEvent */ evt) {
      vm.listDefinitions = evt.models
    },
  }

  var watch = $scope.$watch('vm.channelId', function(newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null) {
      return
    }

    EventService.listSets(newVal).then(function(response) {
      vm.sets = response.results
      vm.waitChannel = false
    })
  })

  vm.loadCustom = function(type) {
    if (type !== 1) {
      vm.addRow.url = ''
      vm.customChannel = null
    } else if (type !== 2) {
      vm.addRow.url = ''
      vm.customSet = null
    } else if (type !== 5) {
      vm.addRow.url = ''
      vm.customBundle = null
    } else if (type !== 7) {
      vm.addRow.url = ''
      vm.customFeature = null
    }
  }

  vm.fillUrl = function() {
    if (vm.model.id !== 0) {
      vm.model.url = 'set_lists/' + vm.customSet + '/sets'
    } else {
      vm.addRow.url = 'set_lists/' + vm.customSet + '/sets'
    }
  }

  vm.fillUrlChannel = function() {
    if (vm.model.id !== 0) {
      vm.model.url = 'channel_lists/' + vm.customChannel + '/channels'
    } else {
      vm.addRow.url = 'channel_lists/' + vm.customChannel + '/channels'
    }
  }

  vm.fillUrlBundle = function() {
    if (vm.model.id !== 0) {
      vm.model.url = 'bundle_lists/' + vm.customBundle + '/bundles'
    } else {
      vm.addRow.url = 'bundle_lists/' + vm.customBundle + '/bundles'
    }
  }

  vm.fillUrlFeature = function() {
    if (vm.model.id !== 0) {
      vm.model.url = 'banner_lists/' + vm.customFeature + '/banners'
    } else {
      vm.addRow.url = 'banner_lists/' + vm.customFeature + '/banners'
    }
  }

  var watch1 = $scope.$watch('vm.titleCustomChannel', function(newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null || newVal === '') {
      if (oldVal) {
        reloadPaginationCustomChannel()
        loadCustomChannel(1)
      }
      return
    }

    if (newVal === false) {
      return
    }

    if (vm.titleCustomChannel.length < 2) {
      return
    }

    reloadPaginationCustomChannel()
    loadCustomChannel(1)
  })

  var watch2 = $scope.$watch('vm.titleCustomSet', function(newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null || newVal === '') {
      if (oldVal) {
        reloadPaginationCustomSet()
        loadCustomSet(1)
      }
      return
    }

    if (newVal === false) {
      return
    }

    if (vm.titleCustomSet.length < 2) {
      return
    }

    reloadPaginationCustomSet()
    loadCustomSet(1)
  })

  var watch3 = $scope.$watch('vm.titleCustomFeature', function(newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null || newVal === '') {
      if (oldVal) {
        reloadPaginationCustomFeature()
        loadCustomFeature(1)
      }
      return
    }

    if (newVal === false) {
      return
    }

    if (vm.titleCustomFeature.length < 2) {
      return
    }

    reloadPaginationCustomFeature()
    loadCustomFeature(1)
  })

  var watch4 = $scope.$watch('vm.titleCustomBundle', function(newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null || newVal === '') {
      if (oldVal) {
        reloadPaginationCustomBundle()
        loadCustomBundle(1)
      }
      return
    }

    if (newVal === false) {
      return
    }

    if (vm.titleCustomBundle.length < 2) {
      return
    }

    reloadPaginationCustomBundle()
    loadCustomBundle(1)
  })

  $scope.$on('$destroy', function() {
    watch()
    watch1()
    watch2()
    watch3()
    watch4()
  })

  vm.pageChangedRows = function(newPage) {
    loadRowType(newPage)
  }

  vm.pageChangedCustomChannel = function(newPage) {
    loadCustomChannel(newPage)
  }

  vm.pageChangedCustomSet = function(newPage) {
    loadCustomSet(newPage)
  }

  vm.pageChangedCustomBundle = function(newPage) {
    loadCustomBundle(newPage)
  }

  vm.pageChangedCustomFeature = function(newPage) {
    loadCustomFeature(newPage)
  }

  vm.csvExploreManager = function() {
    CsvService.validSafari()

    var promise = {}

    ExploreService.listSegments(vm.exploreId).then(function(result) {
      var items = result.results
      var exploreSegmentations = ''
      for (var i = 0; i < items.length; i++) {
        promise[items[i].id] = UserSegmentationService.listUserBySegmentationWithoutPagination(
          items[i].id,
        )
      }

      var listCsv = []
      $q.all(promise).then(function(result) {
        var listUsers = []
        for (var x = 0; x < items.length; x++) {
          var users = result[items[x].id].results
          users.map(function(item) {
            listUsers.push(item)
          })
        }
        listUsers = _.uniqBy(listUsers, 'id')
        for (var j = 0; j < listUsers.length; j++) {
          listCsv.push({
            id: listUsers[j].id,
            username: listUsers[j].username === undefined ? '' : listUsers[j].username,
            email: listUsers[j].email,
            name: listUsers[j].name === undefined ? '' : listUsers[j].name,
          })
        }

        var csv = CsvService.convertArrayOfObjectsToCSV({
          data: listCsv,
        })

        if (csv === null) {
          return
        }

        if (CsvService.isSafari() || CsvService.isFirefox()) {
          var link = document.createElement('a')
          link.id = 'csvDwnLink'

          document.body.appendChild(link)
          window.URL = window.URL || window.webkitURL
          var csv2 = '\ufeff' + csv,
            csvData = 'data:attachment/csv;charset=utf-8,' + encodeURIComponent(csv2),
            filename = vm.nameExplore + '.csv'
          $('#csvDwnLink').attr({ download: filename, href: csvData })
          $('#csvDwnLink')[0].click()
          document.body.removeChild(link)
        } else {
          var filename = vm.nameExplore + '.csv'

          if (!csv.match(/^data:text\/csv/i)) {
            csv = 'data:text/csv;charset=utf-8,' + csv
          }

          var data = encodeURI(csv)
          var link = document.createElement('a')
          link.setAttribute('href', data)
          link.setAttribute('download', filename)
          link.click()
        }
      })
    })
  }

  vm.csvExploreRow = function(item) {
    CsvService.validSafari()

    var explorerRowType = _.find(vm.itemsAll, { id: item.id })

    var promise = {}
    for (var i = 0; i < item['id-us'].length; i++) {
      promise[
        item['id-us'][i].id
      ] = UserSegmentationService.listUserBySegmentationWithoutPagination(item['id-us'][i])
    }

    var listCsv = []
    $q.all(promise).then(function(result) {
      var listUsers = []
      for (var x = 0; x < item['id-us'].length; x++) {
        var users = result[item['id-us'][x].id].results
        users.map(function(item) {
          listUsers.push(item)
        })
      }
      listUsers = _.uniqBy(listUsers, 'id')
      for (var j = 0; j < listUsers.length; j++) {
        listCsv.push({
          id: listUsers[j].id,
          username: listUsers[j].username === undefined ? '' : listUsers[j].username,
          email: listUsers[j].email,
          name: listUsers[j].name === undefined ? '' : listUsers[j].name,
        })
      }

      var csv = CsvService.convertArrayOfObjectsToCSV({
        data: listCsv,
      })

      if (csv === null) {
        return
      }

      if (CsvService.isSafari() || CsvService.isFirefox()) {
        var link = document.createElement('a')
        link.id = 'csvDwnLink'

        document.body.appendChild(link)
        window.URL = window.URL || window.webkitURL
        var csv2 = '\ufeff' + csv,
          csvData = 'data:attachment/csv;charset=utf-8,' + encodeURIComponent(csv2),
          filename = explorerRowType.nm + '.csv'
        $('#csvDwnLink').attr({ download: filename, href: csvData })
        $('#csvDwnLink')[0].click()
        document.body.removeChild(link)
      } else {
        var filename = explorerRowType.nm + '.csv'

        if (!csv.match(/^data:text\/csv/i)) {
          csv = 'data:text/csv;charset=utf-8,' + csv
        }

        var data = encodeURI(csv)
        var link = document.createElement('a')
        link.setAttribute('href', data)
        link.setAttribute('download', filename)
        link.click()
      }
    })
  }

  vm.explorerTranslations = []

  function loadTranslations(item) {
    ExploreRowTypeService.listTranslations(item.id).then(function(result) {
      vm.explorerTranslations = result.results
    })
  }

  vm.translation = function(item) {
    loadTranslations(item)
    vm.rowTypeSelected = item
    $('#modalTranslate').modal('show')
  }

  vm.translate = {}
  vm.addTranslate = function() {
    vm.translate = {}
    $('#modalTranslateAdd').modal('show')
  }

  vm.classDisabled = function() {
    if (!vm.translate.comm || !vm.translate.t || !vm.translate['txt']) {
      return 'is-disabled'
    } else {
      return
    }
  }

  vm.saveTranslate = function() {
    if (vm.translate.id) {
      ExploreRowTypeService.updateTranslation(vm.translate.id, vm.translate).then(
        function() {
          loadTranslations(vm.rowTypeSelected)
          vm.translate = {}
          $('#modalTranslateAdd').modal('hide')
        },
        function(err) {
          swal(err.error.message, '', 'error')
        },
      )
    } else {
      ExploreRowTypeService.createTranslation(vm.rowTypeSelected.id, vm.translate).then(
        function() {
          loadTranslations(vm.rowTypeSelected)
          vm.translate = {}
          $('#modalTranslateAdd').modal('hide')
        },
        function(err) {
          swal(err.error.message, '', 'error')
        },
      )
    }
  }

  vm.editTranslate = function(id) {
    ExploreRowTypeService.getTranslation(id).then(
      function(result) {
        vm.translate = result.results
        $('#modalTranslateAdd').modal('show')
      },
      function(err) {
        swal(err.error.message, '', 'error')
      },
    )
  }

  vm.deleteTranslate = function(id) {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function(isConfirm) {
        if (isConfirm) {
          ExploreRowTypeService.removeTranslation(id).then(
            function() {
              loadTranslations(vm.rowTypeSelected)
              vm.translate = {}
              $('#modalTranslateAdd').modal('hide')
            },
            function(err) {
              $timeout(function() {
                swal(err.error.message, '', 'error')
              }, 500)
            },
          )
        } else {
          return
        }
      },
    )
  }
}
